import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoHobbyCard',
  props: {
    currentCardId: null,
    exampleSentences: null,
    textareaMinRows: null,
    previewErrors: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  exampleSentences?: RirekishoExampleSentences
  textareaMinRows: number
  previewErrors: Record<string, string>
};

const hobbyLabel = '人柄も大切。趣味・特技であなたの個性をアピールしましょう！'



const formatData = useRirekishoFormatData()
const exampleVisible = ref(false)

const hobbyExamples = computed(() => props.exampleSentences?.hobby || [])

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.hobby += item.description.replace(/<br>/gi, '\n') + '\n'
}

return { __sfc: true,hobbyLabel, props, formatData, exampleVisible, hobbyExamples, onSelectExample, NewRirekishoExampleSentenceDialog }
}

})